export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#1B4332] text-white">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16">
          <div>
            <img 
              src="https://static.readdy.ai/image/44d896a69a1929a78f12b3528cb3985b/baaebd26657538e4da185299f5ed494d.png" 
              alt="Legacy Digitization Experts" 
              className="h-12 w-auto mb-4 brightness-0 invert"
            />
            <p className="text-gray-300 text-sm leading-relaxed">
              Expert digitization services preserving your valuable archives with precision, care, and cutting-edge technology for future generations.
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-gray-400 uppercase mb-4 tracking-wide">
              NEWSLETTER
            </h4>
            <p className="text-gray-300 text-sm mb-4">
              Stay updated on preservation best practices
            </p>
            <form className="flex gap-2">
              <input
                type="email"
                placeholder="Your email"
                className="flex-1 bg-transparent border-b border-gray-500 pb-2 text-sm text-white placeholder-gray-500 focus:outline-none focus:border-[#D97706] transition-colors"
              />
              <button type="submit" className="text-[#D97706] hover:text-[#B45309] transition-colors cursor-pointer">
                <i className="ri-arrow-right-line text-xl"></i>
              </button>
            </form>
            <p className="text-gray-500 text-xs mt-3">
              Read our <a href="#" className="underline hover:text-[#D97706]">privacy policy</a>
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-gray-400 uppercase mb-4 tracking-wide">
              SERVICES
            </h4>
            <ul className="space-y-3">
              <li>
                <button onClick={() => scrollToSection('services')} className="text-white hover:text-[#D97706] transition-colors text-sm cursor-pointer whitespace-nowrap">
                  Microfilm Digitization
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('services')} className="text-white hover:text-[#D97706] transition-colors text-sm cursor-pointer whitespace-nowrap">
                  Microfiche Conversion
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('services')} className="text-white hover:text-[#D97706] transition-colors text-sm cursor-pointer whitespace-nowrap">
                  Bound Materials
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('services')} className="text-white hover:text-[#D97706] transition-colors text-sm cursor-pointer whitespace-nowrap">
                  Legacy Media Formats
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-gray-400 uppercase mb-4 tracking-wide">
              CONNECT
            </h4>
            <ul className="space-y-3">
              <li>
                <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="text-white hover:text-[#D97706] transition-colors text-sm flex items-center gap-2 cursor-pointer">
                  <i className="ri-linkedin-fill text-lg"></i> LinkedIn
                </a>
              </li>
              <li>
                <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="text-white hover:text-[#D97706] transition-colors text-sm flex items-center gap-2 cursor-pointer">
                  <i className="ri-twitter-x-fill text-lg"></i> Twitter
                </a>
              </li>
              <li>
                <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="text-white hover:text-[#D97706] transition-colors text-sm flex items-center gap-2 cursor-pointer">
                  <i className="ri-facebook-fill text-lg"></i> Facebook
                </a>
              </li>
              <li>
                <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="text-white hover:text-[#D97706] transition-colors text-sm flex items-center gap-2 cursor-pointer">
                  <i className="ri-instagram-fill text-lg"></i> Instagram
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 pt-12">
          <div className="text-center">
            <h2 className="text-6xl md:text-7xl lg:text-8xl font-bold text-[#D4C5A0] tracking-tight mb-8" style={{ fontFamily: 'Helvetica, Arial, sans-serif' }}>
              LEGACY DIGITIZATION
            </h2>
          </div>
        </div>
      </div>

      <div className="border-t border-gray-700">
        <div className="max-w-7xl mx-auto px-6 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-400">
            <p>
              © {currentYear} Legacy Digitization Experts. All rights reserved.
            </p>
            <div className="flex items-center gap-6">
              <a href="#" className="hover:text-[#D97706] transition-colors">Privacy Policy</a>
              <a href="#" className="hover:text-[#D97706] transition-colors">Terms of Service</a>
              <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="hover:text-[#D97706] transition-colors">
                Website Builder
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
